// removed by extract-text-webpack-plugin
module.exports = {"wrapper-gradient-builder":"magazines_d61KE","wrapper-gradient-builder-palette":"magazines_3gWrK","wrapper-gradient-builder-color-stop-holder":"magazines_DeHsa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/gradientBuilder/styles.scss
// module id = 1230
// module chunks = 1